import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import Accordion from '../LazyWidgets/Accordion';
import { LEGEND_COLORS } from '../../src/ReportsTabs/reports-constants';
import s from './CollapsibleCard.module.css';
import { sendAnalyticsEvent } from '../../src/actions/reports';
import { clickAccordion } from '../../src/analyticsEvents';

const CollapsibleCard = (props) => {
  const {
    children,
    title,
    collapsible = true,
    className,
    reportType,
    ...otherProps
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(collapsible);

  const dispatch = useDispatch();

  const handleOnChange = () => {
    setIsCollapsed(!isCollapsed);
    dispatch(sendAnalyticsEvent(clickAccordion(title, reportType)));
  };

  const titleComponent = collapsible ? (
    <Accordion.AccordionTitle
      className={s.accordionTitle}
      iconClosed={{ type: 'plus', fill: LEGEND_COLORS.BLACK }}
      iconOpen={{ type: 'minus', fill: LEGEND_COLORS.BLACK }}
    >
      <div className={s.accordionTitleText}>{title}</div>
    </Accordion.AccordionTitle>
  ) : (
    <Accordion.AccordionBody className={s.accordionTitle}>
      <h2 className={s.accordionTitleText}>{title}</h2>
    </Accordion.AccordionBody>
  );
  const classes = clsx(s.accordion, className);
  if (!collapsible) {
    otherProps.selectedItemsIndex = [0];
  }
  return (
    <Accordion
      mode="single"
      className={classes}
      onChange={handleOnChange}
      {...otherProps}
    >
      <Accordion.AccordionItem className={s.accordionItem}>
        {titleComponent}
        <Accordion.AccordionBody
          active={!isCollapsed}
          className={s.accordionBody}
        >
          {children}
        </Accordion.AccordionBody>
      </Accordion.AccordionItem>
    </Accordion>
  );
};

CollapsibleCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  collapsible: PropTypes.bool,
  className: PropTypes.string,
  reportType: PropTypes.string,
};

export default CollapsibleCard;
